import { cloneDeep } from "lodash";
import { applyPatch } from "rfc6902";
import { checkChanged } from "./checkChanged";
import {
  ITlfActionProcessSignalRNotification,
  PROCESS_SIGNALR_NOTIFICATION,
  TlfContextProps,
} from "./interface";
import { updateVariantPatchSelection } from "./updateVariantPatchSelection";

/**
 * Applies a remote patch to current data and the independent saved baseline.
 *
 * @param state - Current TLF context state.
 * @param action - SignalR action containing the RFC6902 patch operations.
 * @returns Updated state with the remote changes applied.
 */
export const tlf_processSignalrNotification = (
  state: TlfContextProps,
  action: ITlfActionProcessSignalRNotification,
): TlfContextProps => {
  const newState = { ...state };

  if (!newState.tlfData) {
    throw new Error(
      `tlfContextReducer: ${PROCESS_SIGNALR_NOTIFICATION}:${action.calledFrom}: TLF data not set`,
    );
  }

  newState.tlfData = cloneDeep(newState.tlfData);
  applyPatch(newState.tlfData, action.patch);
  newState.savedTlfData = cloneDeep(state.savedTlfData);
  /* istanbul ignore else */
  if (newState.savedTlfData) applyPatch(newState.savedTlfData, action.patch);
  newState.showModalWindow = "";
  newState.forcePushToParent = true;
  const updatedState = updateVariantPatchSelection(
    newState,
    state.appliedVariantPatches,
    state.activeVariantPatchName,
  );
  checkChanged(updatedState);

  return updatedState;
};
